import {HeroSectionDataType} from 'content/contentTypes'
import classes from './styles.module.css'
import Button from 'components/button/Button'

import appImage from 'assets/icons/home-page/next-hero.webp'
import Link from 'next/link'
import Image from 'next/image'
import Navbar from 'components/navbar/Navbar'
import clsx from 'clsx'
import {heroLastData} from 'content/home-page'

interface ICustomClassName {
  heroContainer?: string,
  topTitle?: string,
  link?: string,
  header?: string,
  desc?: string,
}
interface HeroLayoutProps {
  data: HeroSectionDataType
  showExtraSection?: boolean
  customParentStyle?: React.CSSProperties
  customContainerStyle?: React.CSSProperties
  customFirstSectionStyle?: React.CSSProperties
  customImgStyle?: React.CSSProperties
  heroImageClassName?: string,
  customHeroContainerClassName?: string,
  cutomTopTileClassName?: string,
  customClassName?: ICustomClassName
}

export default function HeroLayout({
  data,
  showExtraSection = false,
  customParentStyle,
  customFirstSectionStyle,
  customContainerStyle,
  customImgStyle,
  heroImageClassName,
  customClassName,
}: HeroLayoutProps) {
  return (
    <div
      className={clsx(classes.parentContainer, showExtraSection ? classes.parentContainerMob : '')}
      style={customParentStyle}
    >
      <div
        className={classes.container}
        style={{paddingBottom: showExtraSection ? '0' : '9rem', ...customContainerStyle}}
      >
        <div className={classes.subContainer}>
          <div className={classes.navBarBlurBg}></div>
          <Navbar />
        </div>
        <div className={clsx(classes.subContainer, classes.heroContainer, customClassName?.heroContainer)}>
          <div className={classes.firstSection} style={customFirstSectionStyle}>
            <h4 className={clsx(classes.topTitle, customClassName?.topTitle)}>
              <span className="textGradient">{data.topTitle}</span>
            </h4>
            <h1 className={clsx('header1', classes.header, customClassName?.header)}>
              {data.title}{' '}
              {!!data.titleVariant && (
                <p style={{color: data.titleVariant.color, display: 'inline'}}>
                  {data.titleVariant.text}
                </p>
              )}
            </h1>
            <p className={clsx(classes.desc, customClassName?.desc)}>{data.desc}</p>
            {data.cta && (
              <Link href={data.cta.link} className={clsx(classes.link, customClassName?.link)} target="_blank">
                <Button text={data.cta.text} />
              </Link>
            )}
          </div>
          <div className={classes.imgContainer}>
            <Image
              style={customImgStyle}
              className={clsx(
                classes.heroImage,
                showExtraSection ? '' : classes.heroImageNoExtraSection,
                heroImageClassName,
              )}
              src={data.imgSrc}
              alt="hero"
              priority
              width={970}
              height={970}
            />
          </div>
        </div>
      </div>
      {showExtraSection && (
        <div className={classes.secondContainer}>
          <div className={classes.background}></div>
          <div className={classes.secondSubContainer}>
            <div className={classes.absoluteImage}>
              <Image
                priority
                className={classes.graphImage}
                src={appImage}
                alt="services"
                width={1374}
                height={667}
              />
            </div>
            <div className={classes.lastImageContainer}>
              {heroLastData.map((cardInfo, idx) => (
                <div
                  key={idx}
                  className={clsx(classes.lastSectionCard, classes[`lastImage${idx}`])}
                >
                  <h4 className={classes.lastImageTitle}>{cardInfo.title}</h4>
                  <div className={classes.images}>
                    {cardInfo.imgs.map((image, idx) => (
                      <Image
                        style={{
                          minHeight: `${image.imgHeight}px`,
                          minWidth: `${image.imgWidth}px`,
                          maxHeight: `${image.imgHeight}px`,
                          maxWidth: `${image.imgWidth}px`,
                        }}
                        key={cardInfo.title}
                        src={image.src}
                        alt={cardInfo.title}
                        height={image?.ratioHeight || image.imgHeight}
                        width={image?.ratioWidth || image.imgWidth}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
